import { NodeKind } from "@/types/data";

const currentYear = new Date().getFullYear();
// Creates dates for January 1st, February 1st, ... May 1st
const fakeDates = [0, 1, 2, 3, 4].map((i) => new Date(currentYear, i, 1));

export const LineGraphPlaceholderData = [
  [
    {
      dataType: "Datetime",
      displayName: "Month",
      uuid: "a",
      value: fakeDates[0],
      formattedValue: fakeDates[0].toLocaleDateString(),
      query: "A",
    },
    {
      dataType: "Number",
      displayName: "Revenue ($)",
      uuid: "b",
      value: 2000,
      formattedValue: "2000",
      query: "B",
    },
    {
      dataType: "Index",
      displayName: "Index",
      uuid: "i",
      value: 0,
      query: "_sf_index__",
    },
  ],
  [
    {
      dataType: "Datetime",
      displayName: "Month",
      uuid: "a",
      value: fakeDates[1],
      formattedValue: fakeDates[1].toLocaleDateString(),
      query: "A",
    },
    {
      dataType: "Number",
      displayName: "Revenue ($)",
      uuid: "b",
      value: 2400,
      formattedValue: "2400",
      query: "B",
    },
    {
      dataType: "Index",
      displayName: "Index",
      uuid: "i",
      value: 1,
      query: "_sf_index__",
    },
  ],
  [
    {
      dataType: "Datetime",
      displayName: "Month",
      uuid: "a",
      value: fakeDates[2],
      formattedValue: fakeDates[2].toLocaleDateString(),
      query: "A",
    },
    {
      dataType: "Number",
      displayName: "Revenue ($)",
      uuid: "b",
      value: 3200,
      formattedValue: "3200",
      query: "B",
    },
    {
      dataType: "Index",
      displayName: "Index",
      uuid: "i",
      value: 2,
      query: "_sf_index__",
    },
  ],
  [
    {
      dataType: "Datetime",
      displayName: "Month",
      uuid: "a",
      value: fakeDates[3],
      formattedValue: fakeDates[3].toLocaleDateString(),
      query: "A",
    },
    {
      dataType: "Number",
      displayName: "Revenue ($)",
      uuid: "b",
      value: 2900,
      formattedValue: "2900",
      query: "B",
    },
    {
      dataType: "Index",
      displayName: "Index",
      uuid: "i",
      value: 3,
      query: "_sf_index__",
    },
  ],
  [
    {
      dataType: "Datetime",
      displayName: "Month",
      uuid: "a",
      value: fakeDates[4],
      formattedValue: fakeDates[4].toLocaleDateString(),
      query: "A",
    },
    {
      dataType: "Number",
      displayName: "Revenue ($)",
      uuid: "b",
      value: 3800,
      formattedValue: "3800",
      query: "B",
    },
    {
      dataType: "Index",
      displayName: "Index",
      uuid: "i",
      value: 4,
      query: "__sf_index__",
    },
  ],
].map((row) => {
  return row.map((node) => {
    return {
      ...node,
      kind: NodeKind.node,
      isArtificial: node.displayName === "Index",
    };
  });
});
